// Onay kuyruğu satırında hücrenin müşteri notu (Dalga 3: not iş parçacığından okunur — eski
// `client_note` kolonu dondu). Hücrede not varsa SON müşteri notu + "Notları aç (n)" bağlantısı
// (iş parçacığı modalı, danışman yanıtlayabilir). Not yoksa hiçbir şey çizilmez ve istek atılmaz.

import { useEffect, useState } from "react";
import type { KpiNoteSummaryCell } from "@mahir/shared";
import { listCellNotes, type NoteCellRef } from "../../api/kpi-notes";
import { KPI_NOTES_COPY } from "../../lib/kpi-notes-copy";

export function KpiQueueNoteLine(props: {
  setId: string;
  cell: NoteCellRef;
  summary: KpiNoteSummaryCell | undefined;
  onOpen: () => void;
}): JSX.Element | null {
  const { setId, cell, summary } = props;
  const C = KPI_NOTES_COPY.internal;
  const [latest, setLatest] = useState<string | null>(null);
  const count = summary?.count ?? 0;
  useEffect(() => {
    if (count <= 0) {
      setLatest(null);
      return;
    }
    let alive = true;
    listCellNotes("internal", setId, cell)
      .then((list) => {
        if (!alive) return;
        const last = [...list].reverse().find((n) => n.authorKind === "client");
        setLatest(last?.body ?? null);
      })
      .catch(() => {
        if (alive) setLatest(null);
      });
    return () => {
      alive = false;
    };
  }, [setId, cell.metricId, cell.entityId, cell.year, count, summary?.lastAuthorKind]);
  if (count <= 0) return null;
  return (
    <div
      className="text-xs"
      data-testid="kpi-queue-client-note"
      style={{ color: "var(--color-text-2)", whiteSpace: "normal", maxWidth: 420 }}
    >
      {latest ? (
        <>
          <b>{C.latestClientNote}:</b> {latest}{" "}
        </>
      ) : null}
      <button
        type="button"
        data-testid="kpi-queue-open-thread"
        onClick={props.onOpen}
        className="underline"
        style={{ color: "var(--color-primary)" }}
      >
        {C.openThread(count)}
      </button>
    </div>
  );
}
